import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function dateRangeValidator(): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
        const dateFrom = group.get('dateFrom')?.value;
        const dateTo = group.get('dateTo')?.value;

        if (!dateFrom && !dateTo) {
            return null; // Пустые поля валидны
        }

        const dateFromParsed = dateFrom ? new Date(dateFrom) : null;
        const dateToParsed = dateTo ? new Date(dateTo) : null;

        if (dateFromParsed && dateToParsed) {

            // Даты должны совпадать
            if (dateFromParsed.toDateString() !== dateToParsed.toDateString()) {
                return { dateMismatch: true };
            }

            // Разница во времени должна быть минимум 1 час
            const diffInHours = (dateToParsed.getTime() - dateFromParsed.getTime()) / (1000 * 60 * 60);
            if (diffInHours < 1) {
                return { minHourDifference: true };
            }

            // Время "dateFrom" не должно быть больше времени "dateTo"
            if (dateFromParsed > dateToParsed) {
                return { invalidOrder: true }; // dateFrom не может быть позже dateTo
            }
        }

        return null; // Валидно
    };
}
